<div class="extra-frame">

  <div *ngIf="user.ID">
    <div class="row">
      <div class="col-md-6 label header">{{ 'bikeshop.modal.shared.cyclist-bike.add_cyclist' | translate}}</div>
      <div *ngIf="user && user.ID" class="col-md-3">
        <button (click)="clearForm()" class="p-button-raised full-width alternate"
                label="{{ 'bikeshop.modal.shedule_service.reset_form' | translate}}" pButton
                type="button"></button>
      </div>
    </div>
    <!-- <div class="row margin-top-8">
      <div class="col-md-12 label fontweight600">
        {{ 'bikeshop.modal.shedule_service.enter_either_email_or_phone_or_both' | translate }}</div>
    </div> -->


    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ "general.name" | translate }}:</div>
      <div class="col-md-3 value">
        <p-inplace #Name>
          <span pInplaceDisplay>
            {{ user.Name }}
          </span>
          <span pInplaceContent>
            <div class="p-inputgroup">
              <input (keyup.enter)="updateCyclist(Name, 'Name')" [(ngModel)]="user.Name" pInputText type="text"/>
              <span (click)="updateCyclist(Name, 'Name')" class="p-inputgroup-addon"><i
                [ngClass]="{ red: user.Name && user.Name.length > 0 }"
                class="fa fa-check"></i></span>
            </div>
          </span>
        </p-inplace>
      </div>
      <div class="col-md-3 label">{{ "general.surname" | translate }}:</div>
      <div class="col-md-4 value">
        <p-inplace #Surname>
          <span pInplaceDisplay>
            {{ user.Surname }}
          </span>
          <span pInplaceContent>
            <div class="p-inputgroup">
              <input (keyup.enter)="updateCyclist(Surname, 'Surname')" [(ngModel)]="user.Surname" pInputText
                     type="text"/>
              <span (click)="updateCyclist(Surname, 'Surname')" class="p-inputgroup-addon"><i [ngClass]="{
                    red: user.Surname && user.Surname.length > 0
                  }"
                                                                                              class="fa fa-check"></i></span>
            </div>
          </span>
        </p-inplace>
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ "general.phone" | translate }}:</div>
      <div class="col-md-3 value">
        <p-inplace #phoneNumber>
          <span pInplaceDisplay>
            {{ user.PhoneNumber }}
          </span>
          <span pInplaceContent>
            <div class="p-inputgroup">
              <input (keyup.enter)="updateCyclist(phoneNumber, 'PhoneNumber')" [(ngModel)]="user.PhoneNumber" pInputText
                     type="text"/>
              <span (click)="updateCyclist(phoneNumber, 'PhoneNumber')" class="p-inputgroup-addon"><i
                [ngClass]="{
                    red: user.PhoneNumber && user.PhoneNumber.length > 0
                  }"
                class="fa fa-check"></i></span>
            </div>
          </span>
        </p-inplace>
      </div>
      <div class="col-md-3 label">{{ "general.email" | translate }}:</div>
      <div class="col-md-4 value">
        <p-inplace #Email>
          <span pInplaceDisplay>
            {{ user.Email }}
          </span>
          <span pInplaceContent>
            <div class="p-inputgroup">
              <input (keyup.enter)="updateCyclist(Email, 'Email')" [(ngModel)]="user.Email" pInputText type="text"/>
              <span (click)="updateCyclist(Email, 'Email')" class="p-inputgroup-addon"><i [ngClass]="{
                    red:  validateEmail()
                  }"
                                                                                          class="fa fa-check"></i></span>
            </div>
          </span>
        </p-inplace>
      </div>
    </div>


  </div>


  <form (ngSubmit)="saveUser(UserForm.value)" [formGroup]="UserForm">
    <div *ngIf="!user.ID">
      <div class="row">
        <div class="col-md-6 label header">{{ 'bikeshop.modal.shared.cyclist-bike.add_cyclist' | translate}}</div>
        <div *ngIf="user && user.ID" class="col-md-3">
          <button (click)="clearForm()" class="p-button-raised full-width alternate"
                  label="{{ 'bikeshop.modal.shedule_service.reset_form' | translate}}" pButton
                  type="button"></button>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-12 label fontweight600">
          {{ 'bikeshop.modal.shedule_service.enter_either_email_or_phone_or_both' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div
          [ngClass]="{'red': user.ID === undefined && UserForm.controls['PhoneNumber'].enabled && !UserForm.value.Email && (!UserForm.value.PhoneNumber || UserForm.value.PhoneNumber.length===0)}"
          class="col-md-2 label iso-label">
          <span
            *ngIf="user.ID === undefined && UserForm.controls['Email'].enabled && (!UserForm.value.Email || UserForm.value.Email.length===0)">*</span>{{
          'general.phone_number' | translate}}:
        </div>
        <div class="col-md-4">

          <div class="position-relative mt-2">

            <span *ngIf="newCustomer" class="new-customer-label">New*</span>
            <input
              (blur)="removeDropdown('PhoneNumber')"
              (focus)="setInputFocus('PhoneNumber')"
              class="form-control iso-input search-input "
              formControlName="PhoneNumber"
              placeholder="{{ 'general.phone_number_placeholder' | translate}}"
              type="text"
            />

            <ul
              *ngIf="inputFocus === 'PhoneNumber'"
              [class.show]="showDropdown && phoneResults && phoneResults.length"
              class="dropdown-menu shadow results-dropdown"
            >
              <li
                (mousedown)="selectUser(cyclist);  $event.preventDefault()"
                *ngFor="let cyclist of phoneResults"
                class="dropdown-item"
              >
                <div>
                  <p class="dropdown-title">
                    {{ cyclist.Name }} {{ cyclist.Surname }}
                  </p>
                  <p class="dropdown-text">
                    {{ cyclist.PhoneNumber ? cyclist.PhoneNumber : 'No Phone Number'  }}
                    |   {{ cyclist.Email ? cyclist.Email : 'No Email' }}
                  </p>
                </div>

              </li>
              <hr *ngIf="phoneResults && phoneResults.length > 1" class="line-separator">
            </ul>

            <span *ngIf="isloading && inputFocus === 'PhoneNumber'" class="hub-loader job-loader"></span>
          </div>


          <!--          <div class="p-inputgroup">-->
          <!--            <p-autoComplete formControlName="PhoneNumber" [suggestions]="cyclists"-->
          <!--                            placeholder="{{ 'general.phone_number_placeholder' | translate}}" [delay]="600"-->
          <!--                            (onSelect)="selectUser($event)" (completeMethod)="searchPhone($event)"-->
          <!--                            [minLength]="9"-->
          <!--            >-->
          <!--              <ng-template let-user pTemplate="item">-->
          <!--                <div><span>{{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}-->
          <!--                  / {{user.Name + ' ' +-->
          <!--                  user.Surname}} / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}}</span></div>-->
          <!--              </ng-template>-->
          <!--            </p-autoComplete>-->
          <!--          </div>-->
        </div>
        <div
          [ngClass]="{'red': user.ID === undefined && UserForm.controls['Email'].enabled && !UserForm.value.PhoneNumber && (!UserForm.value.Email || UserForm.value.Email.length===0)}"
          class="col-md-2 label iso-label">
          <span
            *ngIf="user.ID === undefined && UserForm.controls['PhoneNumber'].enabled && (!UserForm.value.PhoneNumber || UserForm.value.PhoneNumber.length===0)">*</span>{{
          'general.email' | translate}}:
        </div>
        <div class="col-md-4 ">
          <div class="position-relative mt-2 ">
            <span *ngIf="newCustomer" class="new-customer-label">New*</span>

            <input
              (blur)="removeDropdown('Email')"
              (focus)="setInputFocus('Email')"
              class="form-control iso-input search-input "
              formControlName="Email"
              placeholder="{{ 'general.email_placeholder' | translate}}"
              type="email"
            />

            <ul
              *ngIf="inputFocus === 'Email'"
              [class.show]="showDropdown && emailResults && emailResults.length"
              class="dropdown-menu shadow results-dropdown"
            >
              <li
                (mousedown)="selectUser(cyclist);  $event.preventDefault()"
                *ngFor="let cyclist of emailResults"
                class="dropdown-item"
              >
                <p class="dropdown-title">
                  {{ cyclist.Name }} {{ cyclist.Surname }}
                </p>
                <p class="dropdown-text">
                  {{ cyclist.PhoneNumber ? cyclist.PhoneNumber : 'No Phone Number'  }}
                  |   {{ cyclist.Email ? cyclist.Email : 'No Email' }}
                </p>
                <hr *ngIf="emailResults && emailResults.length > 1" class="line-separator">
              </li>

            </ul>

            <span *ngIf="isloading && inputFocus === 'Email'" class="hub-loader job-loader"></span>
          </div>


          <!--          <div class="p-inputgroup">-->
          <!--            <input type="text" pInputText formControlName="Email"-->
          <!--                   placeholder="{{ 'general.email_placeholder' | translate}}"-->
          <!--                   (change)="searchEmail($event)"/>-->
          <!--          </div>-->

          <!--          <div class="p-inputgroup">-->
          <!--            <p-autoComplete formControlName="Email" [suggestions]="cyclists"-->
          <!--                            placeholder="{{ 'general.email_placeholder' | translate}}" [delay]="600"-->
          <!--                            (onSelect)="selectUser($event)" (completeMethod)="searchEmail($event)"-->
          <!--                            [minLength]="3"-->
          <!--            >-->
          <!--              <ng-template let-user pTemplate="email">-->
          <!--                <div><span>{{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}-->
          <!--                  / {{user.Name + ' ' +-->
          <!--                  user.Surname}} / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}}</span></div>-->
          <!--              </ng-template>-->
          <!--            </p-autoComplete>-->
          <!--          </div>-->
        </div>
      </div>

      <div class="row margin-top-8">
        <div
          [ngClass]="{'red': user.ID === undefined && UserForm.controls['Name'].enabled && (!UserForm.value.Name || UserForm.value.Name.length===0)}"
          class="col-md-2 label iso-label">
          *{{ 'general.firstname' | translate}}:
        </div>
        <div class="col-md-4 ml-0">

          <div class="position-relative mt-2">
            <span *ngIf="newCustomer" class="new-customer-label">New*</span>

            <input
              (blur)="removeDropdown('FirstName')"
              (focus)="setInputFocus('FirstName')"
              class="form-control iso-input search-input "
              formControlName="Name"
              placeholder="{{ 'general.firstname_placeholder' | translate}}"
              type="text"
            />

            <ul
              *ngIf="inputFocus === 'FirstName'"
              [class.show]="showDropdown && firstNameResults && firstNameResults.length"
              class="dropdown-menu shadow results-dropdown"
            >
              <li
                (mousedown)="selectUser(cyclist);  $event.preventDefault()"
                *ngFor="let cyclist of firstNameResults"
                class="dropdown-item"
              >
                <p class="dropdown-title">
                  {{ cyclist.Name }} {{ cyclist.Surname }}
                </p>
                <p class="dropdown-text">
                  {{ cyclist.PhoneNumber ? cyclist.PhoneNumber : 'No Phone Number'  }}
                  |   {{ cyclist.Email ? cyclist.Email : 'No Email' }}
                </p>
                <hr *ngIf="firstNameResults && firstNameResults.length > 1" class="line-separator">
              </li>

            </ul>

            <span *ngIf="isloading && inputFocus === 'FirstName'" class="hub-loader job-loader"></span>
          </div>
          <!--          <div class="p-inputgroup">-->
          <!--            <p-autoComplete formControlName="Name" [suggestions]="cyclists" [delay]="1000"-->
          <!--                            placeholder="{{ 'general.firstname_placeholder' | translate}}"-->
          <!--                            [forceSelection]="false"-->
          <!--                            [minLength]="3"-->
          <!--                            (onSelect)="selectUser($event)" (completeMethod)="searchName($event)">-->
          <!--              <ng-template let-user pTemplate="item">-->
          <!--                <div><span>{{user.Name + ' ' + user.Surname}}-->
          <!--                  / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}} /-->
          <!--                  {{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}</span></div>-->
          <!--              </ng-template>-->
          <!--            </p-autoComplete>-->
          <!--          </div>-->
        </div>
        <div class="col-md-2 label iso-label">
          {{ 'general.surname' | translate}}:
        </div>
        <div class="col-md-4 ml-0">
          <div class="position-relative mt-2">
            <span *ngIf="newCustomer" class="new-customer-label">New*</span>

            <input
              (blur)="removeDropdown('LastName')"
              (focus)="setInputFocus('LastName')"
              class="form-control iso-input search-input "
              formControlName="Surname"
              placeholder="{{ 'general.surname_placeholder' | translate}}"
              type="text"
            />

            <ul
              *ngIf="inputFocus === 'LastName'"
              [class.show]="showDropdown && lastNameResults && lastNameResults.length"
              class="dropdown-menu shadow results-dropdown-lastname"
            >
              <li
                (mousedown)="selectUser(cyclist);  $event.preventDefault()"
                *ngFor="let cyclist of lastNameResults"
                class="dropdown-item"
              >
                <p class="dropdown-title">
                  {{ cyclist.Name }} {{ cyclist.Surname }}
                </p>
                <p class="dropdown-text">
                  {{ cyclist.PhoneNumber ? cyclist.PhoneNumber : 'No Phone Number'  }}
                  |   {{ cyclist.Email ? cyclist.Email : 'No Email' }}
                </p>
                <hr *ngIf="lastNameResults && lastNameResults.length > 1" class="line-separator">
              </li>

            </ul>

            <span *ngIf="isloading && inputFocus === 'LastName'" class="hub-loader job-loader"></span>
          </div>

          <!--          -->
          <!--          <div class="p-inputgroup">-->
          <!--            <p-autoComplete formControlName="Surname" [suggestions]="cyclists" [delay]="1000"-->
          <!--                            placeholder="{{ 'general.surname_placeholder' | translate}}"-->
          <!--                            [forceSelection]="false"-->
          <!--                            (onSelect)="selectUser($event)" (completeMethod)="searchSurname($event)">-->
          <!--              <ng-template let-user pTemplate="item">-->
          <!--                <div><span>{{user.Name + ' ' + user.Surname}}-->
          <!--                  / {{user.Email ? user.Email : 'NO EMAIL ADDRESS'}} /-->
          <!--                  {{user.PhoneNumber ? user.PhoneNumber : 'NO PHONE NUMBER'}}</span></div>-->
          <!--              </ng-template>-->
          <!--            </p-autoComplete>-->
          <!--          </div>-->
        </div>
      </div>
    </div>

    <hr *ngIf="bikes && bikes.length>1"/>

    <div *ngIf="bikes && bikes.length>1" class="row margin-top-8">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.select_bike' | translate}}:</div>
      <div class="col-md-4">
        <p-dropdown (onChange)="selectBike(selectedBike)" [(ngModel)]="selectedBike"
                    [ngModelOptions]="{standalone: true}"
                    [options]="bikes"></p-dropdown>
      </div>
      <div class="col-md-3">
        <button (click)="addBike()" class="p-button-raised full-width alternate"
                label="{{ 'bikeshop.modal.shedule_service.add_new_bike' | translate}}" pButton
                type="button"></button>
      </div>
    </div>
    <div *ngIf="selectedBike && selectedBike.ID">
      <div *ngIf="partnerData.PartnerType === 1" class="row margin-top-8">
        <div class="col-md-2 label">{{ 'general.headers.type' | translate}}:</div>
        <div class="col-md-4 value">
          {{getBikeType(selectedBike.TypeID)}}
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'general.manufacturer' | translate}}:</div>
        <div class="col-md-4 value">
          {{selectedBike.Manufacturer}}
        </div>
        <div class="col-md-2 label">{{ 'general.model' | translate}}:</div>
        <div class="col-md-4 value">
          {{selectedBike.Model}}
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.year' | translate}}:</div>
        <div class="col-md-4 value">
          {{selectedBike.ModelYear}}
        </div>
        <div class="col-md-2 label">{{ 'general.color' | translate}}:</div>
        <div class="col-md-4 value">
          {{selectedBike.Colour}}
        </div>
      </div>
    </div>

    <div *ngIf="showAddBike() && (bikes.length === 0 || selectedBike.ID === undefined || addNewBike)">
      <div class="row margin-top-8">
        <div class="col-md-12 label header">{{ 'bikeshop.modal.shared.cyclist-bike.add_a_bike' | translate}}</div>
      </div>
      <div class="row margin-top-8">
        <div
          class="col-md-12 label fontweight600">{{ 'bikeshop.modal.shared.cyclist-bike.add_a_bike_note' | translate }}</div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-2 label">
          {{ 'general.manufacturer' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <p-autoComplete (completeMethod)="searchManufacturer($event)" [forceSelection]="false"
                            [suggestions]="manufacturers" formControlName="Manufacturer"
                            placeholder="{{ 'general.manufacturer' | translate}}">
              <ng-template let-manufacturer pTemplate="item">
                <div><span>{{manufacturer}}</span></div>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
        <div class="col-md-2 label">
          {{ 'general.model' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <p-autoComplete (completeMethod)="searchModel($event)" [forceSelection]="false"
                            [suggestions]="models" formControlName="Model"
                            placeholder="{{ 'general.model' | translate}}">
              <ng-template let-model pTemplate="item">
                <div><span>{{model}}</span></div>
              </ng-template>
            </p-autoComplete>
          </div>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.year' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input formControlName="Year" maxlength="4" pInputText
                   placeholder="{{ 'bikeshop.modal.shared.bike.year' | translate}}"
                   type="number"/>
          </div>
        </div>
        <div class="col-md-2 label">{{ 'general.color' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input formControlName="Color" pInputText placeholder="{{ 'general.color' | translate}}"
                   type="text"/>
          </div>
        </div>
      </div>
      <div class="row margin-top-8">
        <div
          [ngClass]="{'red' : this.partnerData.MandatorySerialNumber && UserForm.controls['SerialNo'].enabled && (!UserForm.value.SerialNo || UserForm.value.SerialNo.length===0)}"
          class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.serial_no' | translate}}
          :
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input formControlName="SerialNo" pInputText
                   placeholder="{{ 'bikeshop.modal.shared.bike.serial_no' | translate}}"
                   type="text"/>
          </div>
        </div>
        <div *ngIf="partnerData.PartnerType === 1"
             class="col-md-2 label">{{ 'general.headers.type' | translate}}:
        </div>
        <div *ngIf="partnerData.PartnerType === 1" class="col-md-4">
          <p-dropdown [options]="bikeTypes" formControlName="TypeID">
          </p-dropdown>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-8"></div>
        <div class="col-md-4">
          <button [disabled]="!UserForm.valid || !valid() || busy" class="p-button-raised full-width"
                  label="{{user.ID ? ('bikeshop.modal.shared.cyclist-bike.button.add_bike' | translate) : ('bikeshop.modal.shared.cyclist-bike.button.create_cyclist' | translate)}}"
                  pButton
                  type="submit"></button>
        </div>
      </div>
    </div>
    <div *ngIf="error" class="row">
      <div class="col-md-12 errormessage">{{errorMessage}}</div>
    </div>
  </form>

  <p-confirmDialog></p-confirmDialog>
</div>
